// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2ORne","upload":"Small_upload__33aO6","imageWrap":"Small_imageWrap__30QW9","removeBtn":"Small_removeBtn__2TFPg"};